type RawSlot = {
  id: string
  start: string
  end: string
  visit_type_short_names: string[]
}

export type ClinicVisitTypeAvailabilityType = {
  id: string
  start: string
  end: string
  visitTypeShortName: string
}

const fetchUsps = async (clinicId: string, lang = "sv-se") => {
  try {
    if (!clinicId) return { status: "Ok", usps: null }

    const response = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/v1/clinic/${clinicId}/webinfo`, {
      method: "GET",
      headers: {
        "Accept-Language": lang
      },
      next: { revalidate: 86400 }
    })

    if (response.status !== 200) {
      return { status: "Not ok", usps: null }
    }

    const usps = await response.json()

    return {
      status: "Ok",
      usps
    }
  } catch (err) {
    return {
      status: 500,
      usps: null
    }
  }
}

const fetchClinicVisitTypeAvailability = async (clinicId: string, visitType: string[], start: string) => {
  try {
    if (!clinicId) return { status: 400, availability: null }

    const params = new URLSearchParams()
    params.append("clinic_id", clinicId)
    params.append("start", start)
    visitType.forEach(type => params.append("visit_type_short_names", type))
    const URL = `${process.env.NEXT_PUBLIC_PLATFORM_URL}/calendar/slots/clinics-availability-slots?${params}`

    const response = await fetch(URL, {
      method: "GET",
      next: { revalidate: 0 }
    })

    if (response.status !== 200) {
      return { status: response.status, availability: null }
    }

    const json = await response.json()

    const seen = new Set<string>()
    const availability: ClinicVisitTypeAvailabilityType[] = json.slots
      .flatMap((slot: RawSlot) =>
        slot.visit_type_short_names.map(shortName => ({
          id: slot.id,
          start: slot.start,
          end: slot.end,
          visitTypeShortName: shortName
        }))
      )
      .filter((slot: ClinicVisitTypeAvailabilityType) => {
        const key = `${slot.visitTypeShortName}:${slot.start}`
        if (seen.has(key)) return false
        seen.add(key)
        return true
      })

    return {
      status: response.status,
      availability
    }
  } catch (err) {
    return {
      status: 500,
      availability: null
    }
  }
}

export { fetchClinicVisitTypeAvailability, fetchUsps }
